import { ReactNode } from "react";

import {
  Flex,
  useBreakpointValue,
  useDisclosure
} from "@/storybook-components";
import ContentArea from "./content-area";
import Sidebar from "./sidebar";

function ColumnLayout({
  aboutContent,
  mainContent,
  actions,
  splitActions
}: {
  aboutContent: ReactNode;
  mainContent: ReactNode;
  actions?: { component: ReactNode; position: "left" | "right" }[];
  splitActions?: boolean;
}) {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });
  const isMobile = useBreakpointValue({ base: true, lg: false }) || false;

  return (
    <Flex width="100%" direction="row" position="relative" minHeight="100vh">
      {isOpen && <Sidebar onClose={onToggle} aboutContent={aboutContent} />}
      {isMobile && isOpen ? null : (
        <ContentArea
          mainContent={mainContent}
          actions={actions}
          onClose={onToggle}
          isOpen={isOpen}
          splitActions={splitActions}
        />
      )}
    </Flex>
  );
}

export default ColumnLayout;
